import { mutateApi, queryApi } from "src/utils/api/ApiMethods"
import { buildQueryString } from "src/utils/api/query_param_helpers"

export const getNightDatatable = (marinaSlug, night, params = {}) => {
  const qs = buildQueryString(params)
  return queryApi(
    `/manage/${marinaSlug}/reservations/night_reservations/${night}${qs}`
  )
}

export const printNightReservations = async ({
  marinaSlug,
  night,
  ids,
  ...params
}) => {
  const response = await mutateApi({
    url: `/manage/${marinaSlug}/reservations/night_reservations/${night}/print`,
    method: "POST",
    data: { ids, ...params },
  })
  return response.data
}

export const getNightSelectableIds = (marinaSlug, night, params = {}) => {
  const qs = buildQueryString(params)
  return queryApi(
    `/manage/${marinaSlug}/reservations/night_reservations/${night}/selectable_ids${qs}`
  )
}

export const getNightCounts = (marinaSlug, night) => {
  return queryApi(
    `/manage/${marinaSlug}/reservations/night_reservations/${night}/counts`
  )
}

export const getSpaceAssignments = (marinaSlug, reservationId) => {
  return queryApi(
    `/manage/${marinaSlug}/reservations/${reservationId}/space_assignments`
  )
}

export const previewBulkMessage = async ({ marinaSlug, night, ids }) => {
  const response = await mutateApi({
    url: `/manage/${marinaSlug}/reservations/night_reservations/${night}/bulk_message_preview`,
    method: "POST",
    data: { ids },
  })
  return response.data
}

export const sendBulkMessage = async ({
  marinaSlug,
  night,
  reservationIds,
  message,
}) => {
  const response = await mutateApi({
    url: `/manage/${marinaSlug}/reservations/night_reservations/${night}/bulk_message`,
    method: "POST",
    data: { reservationIds, message },
  })
  return response.data
}

export const exportNightReservations = async ({ marinaSlug, night, ids }) => {
  const response = await mutateApi({
    url: `/manage/${marinaSlug}/reservations/night_reservations/${night}/bulk_export`,
    method: "POST",
    data: { ids },
  })
  return response.data
}
